import React, { Component } from "react";
import "./App.scss";
import Listdb from "./page/Listdb";
import { dbListThinh, dbType } from "./utils/fbdb";
import { connect } from "react-redux";
import { compose } from "redux";
import { fetchQuote } from "./store/quotes";
import { fetchCategory } from "./store/category";
import { SEARCH } from './helpers/path';
class App extends Component {
  constructor(props) {
    super(props);
    let uid = localStorage.getItem("uid");
    if (!uid) {
      this.props.history.replace("/signin");
    }
  }
  componentDidMount() {
    const { fetchQuotes } = this.props;
    if (!this.props.list.length) {
      dbListThinh.on("value", (snapshot) => {
        let dataDB = [];
        let newVal = snapshot.val();
        for (let id in newVal) {
          dataDB.push({ id, ...newVal[id] });
        }
        this.props.fetchQuotes(dataDB);
      });
    }
  }
  render() {
    return (
      <div>
        <h1 className="logo text-center">Thính app</h1>
        <div className="text-center">
          <button onClick={() => this.props.history.push(SEARCH)} className="search-button m-5">
            Search
          </button>
        </div>

        <div className="container">
          <Listdb />
        </div>
      </div>
    );
  }
}
const withStore = connect((state) => ({
  list: state.quotes.listQuote,
}), (dispatch) => ({
  fetchQuotes: (...params) => dispatch(fetchQuote(...params)),
  fetchCategory: (...params) => dispatch(fetchCategory(...params)),
}));
export default compose(withStore)(App);
